import { render, staticRenderFns } from "./Volunteers.vue?vue&type=template&id=21d760ed&"
import script from "./Volunteers.vue?vue&type=script&lang=js&"
export * from "./Volunteers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports